import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Nav, NavItem, NavLink as RsNavLink } from 'reactstrap';
import Menues from '../Menues';
import SidebarMinimizer from './../SidebarMinimizer';
import { visibleItems, isGroup, firstUrl, findSection } from './menuUtils';


/**
 * Sidebar con las secciones principales. Las subsecciones de la sección activa
 * se muestran como pestañas arriba del contenido (ver SubNav).
 */
class Sidebar extends Component {
  hideMobile() {
    document.body.classList.remove('sidebar-mobile-show');
  }

  renderSection = (section, active) => {
    // Una sección sin subsecciones que abre un modal
    if (!isGroup(section) && section.component) {
      return <section.component key={section.name} nav={section} />;
    }

    const url = firstUrl(section);
    const className = 'nav-link' + (active ? ' active' : '');
    const content = [<i key="icon" className={section.icon}></i>, section.name];
    const isExternal = url && url.substring(0, 4) === 'http';

    return (
      <NavItem key={section.name} onClick={this.hideMobile}>
        {url && !isExternal ?
          <NavLink to={url} className={className} isActive={() => active}>{content}</NavLink> :
          <RsNavLink href={url || '#'} className={className} onClick={e => { if (!url) e.preventDefault(); }}>{content}</RsNavLink>
        }
      </NavItem>
    );
  }

  render() {
    const path = this.props.location.pathname;
    const activeSection = findSection(Menues.items, path);

    return (
      <div className="sidebar">
        <nav className="sidebar-nav">
          <Nav>
            {visibleItems(Menues.items).map(section =>
              this.renderSection(section, section === activeSection)
            )}
          </Nav>
        </nav>
        <SidebarMinimizer />
        <span className="author-brand mx-auto">
          Desarrollado por{' '} <br />
          <a href="http://paradigma.com.ar">Paradigma del Sur s.a.</a>
          {' '} &copy;{new Date().getFullYear()}
        </span>
      </div>
    )
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js